import { Component, forwardRef, inject } from '@angular/core';
import { forkJoin } from 'rxjs';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReadService } from '@common/service/read.service';
import { AlertErrorService } from '@core/service/alert-error.service';
import { HabilitationService } from '@core/service/habilitation.service';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MultiSelectEditComponent } from '../multi-select/multi-select-edit.component';
import { TmwDropdownCmp } from '../select-referentiel/dropdown.component';
import { TmwSwitchInputComponent } from '../switch-input/switch-input.component';
import { SharedModule } from '@shared/shared.module';
import { TmwTranslateDirective } from '@shared/directives/translate.directive';

@Component({
  standalone: true,
  selector: 'resource-edit-dialog',
  templateUrl: './resource-edit-dialog.component.html',
  imports: [CommonModule, FormsModule, NgbModule, MultiSelectEditComponent, forwardRef(() => TmwDropdownCmp), TmwSwitchInputComponent, TmwTranslateDirective],
})
export class ResourceEditComponent {
  readService = inject(ReadService);
  alertService = inject(AlertErrorService);

  _habilitationParams: any = {};
  isUser = false;

  set habilitationParams(params: any) {
    this._habilitationParams = params;
    this.loadAll();
  }

  get habilitationParams() {
    return this._habilitationParams;
  }

  isSaving: boolean = false;

  elementIds: number[] = [];
  elements: any[] = [];

  constructor(
    private habilitationService: HabilitationService,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    // this.loadAll();
  }

  loadAll() {
    this.isSaving = false;
    this.loadAffectations();
  }

  loadAffectations() {
    this.elementIds = [];
    this.elements = [];
    if (this.habilitationParams.roleId) {
      forkJoin([
        this.readService.queryHabilitation(this.habilitationParams.typeRessource, this.habilitationParams.value),
        this.readService.queryResult('ListRessourceParRole', {
          params: {
            typeRessource: this.habilitationParams.typeRessource,
            roleId: this.habilitationParams.roleId,
          },
        }),
      ]).subscribe({
        next: ([allElement, affectedElements]) => {
          this.elementIds = affectedElements.map((el: any) => el.id);
          this.elements = allElement;
        },
      });
    }
  }

  onAssigned(assignedRoles: any[]) {
    if (assignedRoles?.length) {
      this.isSaving = true;
      const assignedIds = assignedRoles.map((role) => role.id || role);
      this.habilitationService.affectationRessourcesEnMasse(this.habilitationParams.roleId, this.habilitationParams.typeRessource, assignedIds).subscribe(() => {
        this.alertService.showOperationSuccess();
        this.elementIds = [...this.elementIds, ...assignedIds];

        this.loadAll();
      });
    }
  }

  onUnassigned(unassignedRoles: any[]) {
    if (unassignedRoles?.length) {
      this.isSaving = true;
      const unassignedIds = unassignedRoles.map((role) => role.id || role);
      this.habilitationService.suppAffectationRessourcesEnMasse(this.habilitationParams.roleId, this.habilitationParams.typeRessource, unassignedIds).subscribe(() => {
        this.alertService.showOperationSuccess();
        this.elementIds = this.elementIds.filter((id) => !unassignedIds.includes(id));
        this.loadAll();
      });
    }
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
